// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 
The MIT License (MIT)

Copyright (c) 2018 Outer Labs, Inc.

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.
*/

.ForgeViewer {
    position: relative;
    width: 100%;
    height: 85%;
}

  .ForgeViewer .scrim{
    position:relative;
    width: 100%;
    height:100%;
    z-index: 1000;
    background-color:#ededed;
    color: #95a5a6;
    display:flex;
    align-items: center;
    justify-content: center;
  }
  
  .ForgeViewer .scrim .message{
    display:flex;
    flex-direction: column;
    align-items: center;
  }
  
  .ForgeViewer .scrim .message svg{
    margin-bottom:10px;
    width:50px;
    height:50px;
  }

  .ForgeViewer .adsk-viewing-viewer .explode-submenu {
    bottom: 55px;
    cursor: default;
    height: 34px;
    left: 80px;
    min-height: 0;
    min-width: 0;
    position: absolute;
    transform: translateX(-50%);
    width: 160px;
}

.ForgeViewer .adsk-viewing-viewer.notouch.dark-theme.quality-text {
    position: static !important;
}
`, "",{"version":3,"sources":["webpack://./src/pages/index.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;;;CAsBC;;AAED;IACI,kBAAkB;IAClB,WAAW;IACX,WAAW;AACf;;EAEE;IACE,iBAAiB;IACjB,WAAW;IACX,WAAW;IACX,aAAa;IACb,wBAAwB;IACxB,cAAc;IACd,YAAY;IACZ,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,YAAY;IACZ,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,WAAW;EACb;;EAEA;IACE,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,UAAU;IACV,aAAa;IACb,YAAY;IACZ,kBAAkB;IAElB,2BAA2B;IAC3B,YAAY;AAChB;;AAEA;IACI,2BAA2B;AAC/B","sourcesContent":["/* \nThe MIT License (MIT)\n\nCopyright (c) 2018 Outer Labs, Inc.\n\nPermission is hereby granted, free of charge, to any person obtaining a copy\nof this software and associated documentation files (the \"Software\"), to deal\nin the Software without restriction, including without limitation the rights\nto use, copy, modify, merge, publish, distribute, sublicense, and/or sell\ncopies of the Software, and to permit persons to whom the Software is\nfurnished to do so, subject to the following conditions:\n\nThe above copyright notice and this permission notice shall be included in all\ncopies or substantial portions of the Software.\n\nTHE SOFTWARE IS PROVIDED \"AS IS\", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR\nIMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,\nFITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE\nAUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER\nLIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,\nOUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE\nSOFTWARE.\n*/\n\n.ForgeViewer {\n    position: relative;\n    width: 100%;\n    height: 85%;\n}\n\n  .ForgeViewer .scrim{\n    position:relative;\n    width: 100%;\n    height:100%;\n    z-index: 1000;\n    background-color:#ededed;\n    color: #95a5a6;\n    display:flex;\n    align-items: center;\n    justify-content: center;\n  }\n  \n  .ForgeViewer .scrim .message{\n    display:flex;\n    flex-direction: column;\n    align-items: center;\n  }\n  \n  .ForgeViewer .scrim .message svg{\n    margin-bottom:10px;\n    width:50px;\n    height:50px;\n  }\n\n  .ForgeViewer .adsk-viewing-viewer .explode-submenu {\n    bottom: 55px;\n    cursor: default;\n    height: 34px;\n    left: 80px;\n    min-height: 0;\n    min-width: 0;\n    position: absolute;\n    -webkit-transform: translateX(-50%);\n    transform: translateX(-50%);\n    width: 160px;\n}\n\n.ForgeViewer .adsk-viewing-viewer.notouch.dark-theme.quality-text {\n    position: static !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
